/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_InviteInputs */

const th_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เชิญผู้เข้าร่วมอีกคน`)
};

const en_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite the other participant`)
};

const ja_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相手を招待`)
};

const zh_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请另一个人`)
};

const es_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invita al otro participante`)
};

const pt_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convide o outro participante`)
};

const id_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undang orang kedua`)
};

const fr_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitez l’autre participant`)
};

const tl_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyayahan ang ikalawang tao`)
};

const vi_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mời người thứ hai`)
};

const ko_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상대방 초대하기`)
};

const de_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade die andere Person ein`)
};

const ru_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пригласите второго участника`)
};

const tr_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İkinci kişiyi davet edin`)
};

const it_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invita l'altra persona`)
};

const pl_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaproś drugą osobę`)
};

const uk_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросіть другого учасника`)
};

const hi_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दूसरे व्यक्ति को आमंत्रित करें`)
};

const ar_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ادعُ الشخص الآخر`)
};

const ms_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jemput orang kedua`)
};

const bn_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দ্বিতীয় জনকে আমন্ত্রণ করুন`)
};

const zh_tw2_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請另一個人`)
};

const zh_hk2_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請另一個人`)
};

const ur_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دوسرے شخص کو مدعو کریں`)
};

const fa_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نفر دوم را دعوت کنید`)
};

const sw_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alika mtu wa pili`)
};

const nl_meeting_test_invite = /** @type {(inputs: Meeting_Test_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodig de tweede persoon uit`)
};

/**
* | output |
* | --- |
* | "Invite the other participant" |
*
* @param {Meeting_Test_InviteInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_invite = /** @type {((inputs?: Meeting_Test_InviteInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_InviteInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_invite(inputs)
	if (locale === "ja") return ja_meeting_test_invite(inputs)
	if (locale === "zh") return zh_meeting_test_invite(inputs)
	if (locale === "es") return es_meeting_test_invite(inputs)
	if (locale === "pt") return pt_meeting_test_invite(inputs)
	if (locale === "id") return id_meeting_test_invite(inputs)
	if (locale === "fr") return fr_meeting_test_invite(inputs)
	if (locale === "tl") return tl_meeting_test_invite(inputs)
	if (locale === "vi") return vi_meeting_test_invite(inputs)
	if (locale === "ko") return ko_meeting_test_invite(inputs)
	if (locale === "de") return de_meeting_test_invite(inputs)
	if (locale === "ru") return ru_meeting_test_invite(inputs)
	if (locale === "tr") return tr_meeting_test_invite(inputs)
	if (locale === "it") return it_meeting_test_invite(inputs)
	if (locale === "pl") return pl_meeting_test_invite(inputs)
	if (locale === "uk") return uk_meeting_test_invite(inputs)
	if (locale === "hi") return hi_meeting_test_invite(inputs)
	if (locale === "ar") return ar_meeting_test_invite(inputs)
	if (locale === "ms") return ms_meeting_test_invite(inputs)
	if (locale === "bn") return bn_meeting_test_invite(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_invite(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_invite(inputs)
	if (locale === "ur") return ur_meeting_test_invite(inputs)
	if (locale === "fa") return fa_meeting_test_invite(inputs)
	if (locale === "sw") return sw_meeting_test_invite(inputs)
	if (locale === "nl") return nl_meeting_test_invite(inputs)
	return en_meeting_test_invite(inputs)
});